<template>
    <div class="card asignatura-view" >
        <div class="card-body">
            <div class="d-flex justify-content-between">
                <div>
                    <h5 class="card-title mb-1">{{planesEstudio.nombre}}</h5>
                    <h6 v-if="planesEstudio.programa"
                        class="card-subtitle m-0 text-muted"
                    >{{planesEstudio.programa.nombre}}</h6>
                </div>
                <div class="mt-2">
                    <vs-button
                        size="small"
                        @click="activeCrearArea =! activeCrearArea"
                    >
                        <i class="fas fa-plus mr-2"></i>Crear área
                    </vs-button>
                </div>
            </div>
        </div>
        <div class="card-footer text-muted p-0 m-0" style="overflow: auto;">
            <table class="table">
                <tbody>
                    <tr v-for="area in planesEstudio.areas" :key="area.id">
                        <td>
                            <div class="cabecera text-center">
                                <div>
                                    <div class="d-flex" style="justify-content: center;"  @click="activeEditarArea =! activeEditarArea, selectArea = area">
                                       <h6>{{area.nombre}} </h6> <i class="fas fa-edit ml-1" style="font-size: 0.5rem; color: gray;"></i> 
                                    </div>
                                    
                                    <vs-button
                                        border
                                        size="mini"
                                        @click="activeCrearAsignatura =! activeCrearAsignatura, areaId = area.id"
                                    >
                                        Crear Asignatura
                                    </vs-button>
                                </div>
                            </div>

                            <draggable v-model="area.asignaturas" group="asignaturas"
                                style="display: flex;"
                                @change="rearrangeAsignatura(area)">
                                <transition-group style="display: flex;">
                                    <div v-for="asignatura in area.asignaturas" :key="asignatura.id"
                                        :class="'asignatura asig-'+asignatura.estilo"
                                        @click="activeEditarAsignatura =! activeEditarAsignatura, selectRow = asignatura">
                                        <span class="text-center m-2">{{asignatura.nombre}}</span>
                                    </div>
                                </transition-group>
                            </draggable>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <crear-asignatura v-model="activeCrearAsignatura" :plan="plan" :areaId="areaId" @refreshTable="getRefresh"></crear-asignatura>
        <editar-asignatura v-model="activeEditarAsignatura" :plan="plan" :areaId="areaId" :selectRow="selectRow" @refreshTable="getRefresh"></editar-asignatura>
        <editar-area v-model="activeEditarArea" :selectArea="selectArea" :programa="programa" @refreshTable="getRefresh"></editar-area>
        <crear-area v-model="activeCrearArea" :programa="programa" :plan="plan" @refreshTable="getRefresh"></crear-area>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import CrearAsignatura from './modal/crear_asignatura.vue'
import EditarAsignatura from './modal/editar_asignatura.vue'
import CrearArea from './modal/crear_area.vue'
import EditarArea from './modal/editar_area.vue'
import academico from '../../../../api/requests/academico'
export default {
    components: {
        draggable,
        CrearAsignatura,
        EditarAsignatura,
        CrearArea,
        EditarArea
    },
    props:[
        'planesEstudio',
        'plan',
        'programa'
    ],
    data(){
        return{
            selectRow: [],
            selectArea: [],
            activeCrearAsignatura: false,
            activeEditarAsignatura: false,
            activeCrearArea: false,
            activeEditarArea: false,
            areaId: '',
            planPrograma: ''
        }
    },
    methods: {
        getRefresh(){
            this.$emit('refreshTable')
        },
        async rearrangeAsignatura(area) {
            const request = [];
            let count = 0;
            for (const asignatura of area.asignaturas) {
                request.push({
                asignatura_id: asignatura.id,
                area_id: area.id,
                order: count
                });

                count++;
            }
            const response = await academico.rearrangeAsignatura(request)
            this.$emit('refreshTable')
        },
    }
}
</script>

<style scoped>
.asignatura-view .cabecera{
    width: 150px;
}
</style>